import { MouseEventHandler, ReactNode } from 'react';

import { VideoSize } from 'types/Video/VideoSize';
import { useVideoSize } from 'utils/video';

import {
  VideoThumbnailButtonHolder,
  VideoThumbnailHolder,
} from './VideoThumbnailContainer.styled';

type Props = {
  children: ReactNode;
  size: VideoSize;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export function VideoThumbnailContainer({ children, size, onClick }: Props) {
  const { width, height } = useVideoSize(size);

  if (onClick) {
    return (
      <VideoThumbnailButtonHolder
        type="button"
        onClick={onClick}
        style={{ width, height }}
      >
        {children}
      </VideoThumbnailButtonHolder>
    );
  }

  return (
    <VideoThumbnailHolder style={{ width, height }}>
      {children}
    </VideoThumbnailHolder>
  );
}
